import React from 'react';

export interface CustomIconQrDigitalChannelProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

export function CustomIconQrDigitalChannel({ width, height, ...props }: CustomIconQrDigitalChannelProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.5 5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 1-1V5ZM23 5a1 1 0 0 0-1-1h-4.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1H22a1 1 0 0 0 1-1V5ZM12.5 17a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 1-1v-5Z"
        clipRule="evenodd"
      />
      <path
        fill="#1C1C28"
        d="M15.429 22.906V15.72c0-.396.321-.719.714-.719H19c.393 0 .714.323.714.719 0 .395.322.719.715.719h1.428a.719.719 0 0 0 .714-.72c0-.395.322-.718.715-.718.393 0 .714.323.714.719v4.312a.719.719 0 0 1-.714.719h-2.857a.719.719 0 0 1-.715-.719.719.719 0 0 0-.714-.718.719.719 0 0 0-.714.718v2.875a.719.719 0 0 1-.715.719h-1.428a.719.719 0 0 1-.714-.719Z"
      />
      <path
        fill="#1C1C28"
        d="M19.924 22.398a.712.712 0 0 1 1.219.508c0 .19-.075.374-.21.509a.712.712 0 0 1-1.219-.509.72.72 0 0 1 .21-.508ZM22.78 22.398a.712.712 0 0 1 1.22.508c0 .19-.075.374-.21.509a.712.712 0 0 1-1.219-.509c0-.19.076-.373.21-.508Z"
      />
    </svg>
  );
}
